import { Icon } from "semantic-ui-react";

const HistoricalTab = ({ t }) => {
	return (
		<span>
			<Icon name="history" size="small" /> {t("subMenu.historic")}
		</span>
	);
};

export default HistoricalTab;
